import React, {Component} from 'react';
import PropTypes from 'prop-types';
import enquire from 'enquire.js';
import {observer} from 'mobx-react';
import Collapse from 'react-bootstrap/lib/Collapse';
import SearchSummary from './SearchSummary';
import {MOBILE_WIDTH} from 'helpers/stableValues';
import {resultsTranslations, searchMaskTranslations} from 'helpers/translations';

class CollapsedSearchMask extends Component {
  state = {
    collapsed: null
  };

  componentDidMount() {
    enquire.register(`screen and (max-width: ${MOBILE_WIDTH}px)`, {
      setup: () => {
        const {collapsed} = this.state;
        this.setState({collapsed: collapsed === null ? false : collapsed});
      },
      match: () => {
        const {collapsed} = this.state;
        this.setState({collapsed: collapsed === null ? true : collapsed});
      },
      unmatch: () => {
        const {collapsed} = this.state;
        this.setState({collapsed: collapsed === null ? false : collapsed});
      }
    });
  }

  handleCollapse = () => {
    this.setState(({collapsed}) => (
      {collapsed: !collapsed}
    ));
  };

  render() {
    const {children, store: {query}} = this.props;
    const {collapsed} = this.state;
    const validQuery = !!query.dep;
    const {hideSearchMask} = resultsTranslations;
    const translations = {
      ...resultsTranslations,
      ...searchMaskTranslations
    };

    return (
      <div className="masthead">
        <div className="container">
          <Collapse in={!collapsed || !validQuery}>
            <div>
              {
                validQuery &&
                  <div className="text-right">
                    <a
                      className="text-muted"
                      onClick={() => this.handleCollapse()}
                    >
                      <span className="text-small mr-2">
                        {hideSearchMask}
                      </span>
                      <i className="icon icon-up-arrow icon-sm"></i>
                    </a>
                  </div>
              }
              {children}
            </div>
          </Collapse>
          {
            validQuery && collapsed &&
              <SearchSummary query={query} translations={translations} handleCollapse={this.handleCollapse}/>
          }
        </div>
      </div>
    );
  }
}

CollapsedSearchMask.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node
  ]),
  store: PropTypes.object.isRequired
};

export default observer(CollapsedSearchMask);
